module.exports = __webpack_public_path__ + "static/img/autumn_banner.ad40e2f0.jpg";